// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__7TNQU{
    box-sizing: border-box;
    display:flex;
    justify-content: center;
    align-items:center;
    width:100%;
    height:auto;
    flex-wrap:wrap;
}
.style_container__7TNQU>div{
    height:auto;
    width:100px;
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius:8px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ConfirmationButton/style.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".container{\n    box-sizing: border-box;\n    display:flex;\n    justify-content: center;\n    align-items:center;\n    width:100%;\n    height:auto;\n    flex-wrap:wrap;\n}\n.container>div{\n    height:auto;\n    width:100px;\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    border-radius:8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__7TNQU`
};
export default ___CSS_LOADER_EXPORT___;
